import React, { useState } from "react"
import PropTypes from "prop-types"
import { StyledField } from "./styles"

const FLIGHT_NUMBER_REGEX = /^[1-9][0-9]*$/

const FlightNumberField = ({ handleInputChange, ...rest }) => {
  const [invalid, setInvalid] = useState(false)
  const onChange = (event) => {
    const { name, value } = event.target

    if (value === "") setInvalid(false)
    else setInvalid(!FLIGHT_NUMBER_REGEX.test(value))

    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return <StyledField type="text" onChange={onChange} {...rest} invalid={invalid} />
}

FlightNumberField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  invalid: PropTypes.bool
}

FlightNumberField.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  invalid: false
}

export default FlightNumberField
